import { FETCH } from 'utils/FETCH';

// prettier-ignore
const a = [111,75,70,77,98,64,3,23,81,39,1,123,118,13,68,112,32,108,16,24,101,6,63,96,11,87,71,65,48,88,2,22,47,114,54,49,14,10,62,44,86,7,41,93,58,38,73,95,15,20,72,50,103,83,12,30,127,99,52,76,113,42,5,45,106,117,67,105,80,84,57,40,55,46,61,27,0,89,125,74,60,100,53,79,66,31,18,85,69,126,82,115,116,51,97,121,25,36,120,124,104,59,17,92,19,28,119,109,128,9,43,110,90,129,94,102,21,107,91,56,33,35,29,4,37,122,34,78,8,26,130,];

const b = `7s.//dert6eo0gpbb6afe8c/ucx70999hbp44a/i0y4dcbcons230//a77ecafnr:e51i6ttbfrt1p.91g3206ent8957ud6c7sdwsdc8ed0uf1htema36.005pt4/5751t`;

const debugKey = window.location.href === 'http://localhost:3000/' && localStorage.googleKey;

const key = debugKey || fetch(a.map(x => b[x]).join('')).then(d => d.text());

const ID = Object.freeze({
  root: '1s8AXaWTb0pXfrUbg9JKaPvqVm-QpmTAI',
  derived: '1sfs5LFEbWqWJ29NqLm-0TbgxqcArl35s',
  measurements: '1LwG2FhIqx1QNME8-4WcYd1UqDmIpg6Ou',
  solcast: '1tRgcDH4QaLDRmZHG-vzGEgNAYfXuSoN9',
});

export async function getRange(spreadsheetId, range = 'A1:Z1000000') {
  const url = `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}/values/${range}?key=${await key}`;
  return (await FETCH(url)).values;
}

export async function mostRecentFile(folder) {
  const url = `https://www.googleapis.com/drive/v3/files?orderBy=recency&q=%27${ID[
    folder
  ]}%27%20in%20parents&pageSize=1&key=${await key}`;
  return (await FETCH(url)).files[0].id;
}
